/**
 * Inovua ReactDataGrid pode rejeitar promises com valores não-Error ao navegar com Tab:
 * - Row.js: `Promise.reject(null)` (mitigado também por patch em Row.js)
 * - Cell/index.js `startEdit`: `Promise.reject(editable)` quando `editable === false` (célula só leitura)
 *
 * O overlay do CRA mostra "Unknown promise rejection reason" para estes casos.
 */
function isBenignInovuaTabRejection(reason) {
  if (reason == null) {
    return true;
  }
  if (reason === false) {
    return true;
  }
  return false;
}

if (typeof window !== "undefined") {
  window.addEventListener(
    "unhandledrejection",
    function suppressBenignGridRejections(event) {
      if (!isBenignInovuaTabRejection(event.reason)) {
        return;
      }
      event.preventDefault();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
    },
    true
  );
}
